export enum AribaApiType {
  EXTRACT = 'Extract',
  DISCOVERY = 'Discovery',
  RETRIEVAL = 'Retrieval',
  REALM = 'Realm',
  REGION = 'Region',
}
